const PAGE_META = [
  {
    match: (path) => path === '/dashboard/home' || path.startsWith('/dashboard/home/'),
    title: 'Dashboard',
    subtitle: 'Monitor nurturer activity across your organization',
  },
  {
    match: (path) => path === '/dashboard/users/create',
    title: 'Add user',
    subtitle: 'Invite a new nurturer user by email',
  },
  {
    match: (path) => path === '/dashboard/student-stats' || path.startsWith('/dashboard/student-stats'),
    title: 'User messages',
    subtitle: 'Generated nurture messages for this account',
  },
  {
    match: (path) => path === '/dashboard/users/create' || path.startsWith('/dashboard/users'),
    title: 'Users',
    subtitle: 'Manage nurturer accounts in your organization',
  },
  {
    match: (path) => path === '/dashboard/subscription' || path.startsWith('/dashboard/subscription'),
    title: 'Subscription',
    subtitle: 'Manage billing plans for your organization',
  },
  {
    match: (path) => path === '/dashboard/settings' || path.startsWith('/dashboard/settings'),
    title: 'Settings',
    subtitle: 'Organization invite link and account security',
  },
];

const DEFAULT_META = {
  title: 'Nurturer Company',
  subtitle: 'Admin dashboard',
};

export function getPageMeta(pathname = '') {
  const match = PAGE_META.find((entry) => entry.match(pathname));
  return match || DEFAULT_META;
}
